<div class="nav-items-group-container">
  <ng-content />
</div>
